import { ButtonDefault } from '../../ui/buttons/ButtonDefault';
import styles from './AsideElementRestart.module.scss';

function AsideElementRestart({ handleSetTutorial }) {
  return (
    <div className={styles["restart"]}>
      <ButtonDefault text={"restart tutorial"} handler={() => handleSetTutorial(0)} shadow={false} wide />
    </div>

    
  )
}

export default AsideElementRestart;